import { Controller } from "@hotwired/stimulus"

// Horizontal-scroll carousel for the "Recent signals from your
// markets" hero. User can scroll with trackpad / swipe, or hit the
// prev/next buttons / dots. Position indicator updates as the user
// scrolls so they always know where they are in the stack.
export default class extends Controller {
  static targets = ["track", "position", "dot"]

  connect() {
    this.index = 0
    this.boundOnScroll = this.onScroll.bind(this)
    this.trackTarget.addEventListener("scroll", this.boundOnScroll, { passive: true })
    this.update()
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.boundOnScroll)
  }

  prev() {
    this.index = Math.max(0, this.index - 1)
    this.scrollToIndex()
  }

  next() {
    this.index = Math.min(this.slideCount - 1, this.index + 1)
    this.scrollToIndex()
  }

  goto(event) {
    const i = parseInt(event.currentTarget.dataset.index, 10)
    if (Number.isNaN(i)) return
    this.index = Math.max(0, Math.min(this.slideCount - 1, i))
    this.scrollToIndex()
  }

  onScroll() {
    // Derive the active index from the current scrollLeft against
    // slide width. Keeps the dots + position label in sync when the
    // user drags the track directly (vs clicking a button).
    const slide = this.slides[0]
    if (!slide) return
    const slideWidth = slide.getBoundingClientRect().width + this.gap()
    const nearest = Math.round(this.trackTarget.scrollLeft / slideWidth)
    if (nearest !== this.index) {
      this.index = Math.max(0, Math.min(this.slideCount - 1, nearest))
      this.update()
    }
  }

  scrollToIndex() {
    const slide = this.slides[this.index]
    if (!slide) return
    this.trackTarget.scrollTo({
      left: slide.offsetLeft - this.trackTarget.offsetLeft,
      behavior: "smooth",
    })
    this.update()
  }

  update() {
    if (this.hasPositionTarget) {
      this.positionTarget.textContent = `${this.index + 1} / ${this.slideCount}`
    }
    if (this.hasDotTarget) {
      this.dotTargets.forEach((d, i) => {
        d.classList.toggle("gs-hero-signals-dot--active", i === this.index)
      })
    }
  }

  get slides() {
    return Array.from(this.trackTarget.querySelectorAll(".gs-hero-signals-slide"))
  }

  get slideCount() {
    return this.slides.length
  }

  gap() {
    const parsed = parseFloat(getComputedStyle(this.trackTarget).columnGap || "0")
    return Number.isFinite(parsed) ? parsed : 0
  }
}
